// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"750":"5d18e220","790":"0fea7053","875":"b37fad64"}[chunkId] + ".chunk.js";
};